// --- NEW FILE: apps/website/src/stores/ui/historyModal.slice.ts ---

import type { StateCreator } from 'zustand';

export interface HistoryModalState {
  isHistoryOpen: boolean;
  historyEntityType?: 'project' | 'sprint' | 'task';
  historyEntityId?: string;
}

export interface HistoryModalSlice {
  historyModal: HistoryModalState;
  openHistoryModal: (entityType: 'project' | 'sprint' | 'task', entityId: string) => void;
  closeHistoryModal: () => void;
}

export const createHistoryModalSlice: StateCreator<HistoryModalSlice, [], [], HistoryModalSlice> = (set) => ({
  historyModal: {
    isHistoryOpen: false,
  },
  openHistoryModal: (entityType, entityId) => set({
    historyModal: {
      isHistoryOpen: true,
      historyEntityType: entityType,
      historyEntityId: entityId,
    }
  }),
  closeHistoryModal: () => set(state => ({
    historyModal: { ...state.historyModal, isHistoryOpen: false }
  })),
});